export var GROUP_NUTZER = 'Nutzer';
export var GROUP_ADMIN = 'Administrator';
export var GROUP_LWK = 'LWKMitarbeiter';
export var GROUP_EXTERN = 'ExternerNutzer';
export var NUTZERGRUPPEN = [
    GROUP_NUTZER,
    GROUP_ADMIN,
    GROUP_LWK,
    GROUP_EXTERN,
];
